var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('FeedbackSubheader'),_c('p',{staticClass:"mb-2"},[_vm._v("Net Promoter Score")]),_c('TeamMembersNPS')],1)}
var staticRenderFns = []

export { render, staticRenderFns }